// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1d875628","455":"8b66dd9b","977":"ed32ed9f"}[chunkId] + ".chunk.js";
};